import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'tiempoRelativo',
})
export class TiempoRelativoPipe implements PipeTransform {

    transform(value: string | null | undefined): string {
        if (!value) return '';

        const fecha = new Date(value);
        const diffMs = Date.now() - fecha.getTime();

        const minutos = Math.floor(diffMs / 60000);
        const horas = Math.floor(minutos / 60);
        const dias = Math.floor(horas / 24);

        if (minutos < 1) return 'Hace unos segundos';
        if (minutos < 60) return `Hace ${minutos} min`;
        if (horas < 24) return `Hace ${horas} h`;
        if (dias === 1) return 'Ayer';

        return `Hace ${dias} días`;
    }
}
